import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';

interface FooterLink {
  id: string;
  label: string;
  url: string;
  section: string;
  order: number;
}

interface FooterProps {
  links?: FooterLink[];
}

export const Footer: React.FC<FooterProps> = ({ links = [] }) => {
  return (
    <footer className="py-8 bg-white border-t border-gray-200">
      <div className="container mx-auto px-6">
        {links.length > 0 && (
          <div className="flex flex-wrap justify-center items-center gap-6 mb-6">
            {links.map((link) => (
              <div key={link.id}>
                {link.url.startsWith('http') ? (
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm font-light text-primary-600 hover:text-primary-900 transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                ) : (
                  <Link
                    to={link.url}
                    className="text-sm font-light text-primary-600 hover:text-primary-900 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                )}
              </div>
            ))}
          </div>
        )}

        <div className="flex justify-center mb-4">
          <a
            href="https://www.instagram.com/merchantfloor"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Merchant Floor on Instagram"
            className="text-primary-600 hover:text-primary-900 transition-colors duration-200"
          >
            <Instagram className="w-5 h-5" />
          </a>
        </div>

        <div className="text-center">
          <p className="text-sm font-light text-gray-500">
            &copy; {new Date().getFullYear()} Merchant Floor - All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
